import React, { Fragment } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import NotificationComponent from "./notification";
import { Box, Layer } from 'grommet';
import _ from 'lodash';



const styles = {
  transparent: {
    'background': 'rgba(0, 0, 0, 0)',
    'position': 'fixed',
    'top': '20px',
    'width': '500px',
    'text-align': 'center'
  }
};

class NotificationsComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      defaultParams: {
          position: 'bottom-left',//Position in window, uses Grommet Layer positions
          delay: 500, //Delay before showing
          timeout: 5000, //Delay before deleting after showing
          clickToClose: true, // Show button to manual delete notification
          maxItemsInQueue: 5, //Maximum items in queue
          color: '#00C781' //Color of background
      },
      Queue: [],
      id: 0
    }
  }

  deleteNotificationsFromQueue = (id) => {
    let tempQueue = [...this.state['Queue']];
    let findedItem = _.findIndex(tempQueue, item => item['id'] == id);
    if(findedItem != -1) {
      tempQueue.splice(findedItem, 1);
      this.setState({
        Queue: [...tempQueue]
      });
    }
  }

  getColorByType(type) {
    switch (type) {
      case 'success':
        return '#00C781';
      case 'info':
        return '#00739D';
      case 'warning':
        return '#FFAA15';
      case 'error':
        return '#FF4040';
      default:
        return false;
    }
  }

  addNotification(title, body, type, params = {}) {
    let { defaultParams, id, Queue } = this.state;
    if(type) params['color'] = this.getColorByType(type) || type;
    const itemParams = {...defaultParams, ...params};

    let notification = {
        title,
        body,
        color: itemParams.color,
        delay: itemParams.delay,
        timeout: itemParams.timeout,
        position: itemParams.position,
        clickToClose: itemParams.clickToClose,
        id: id++,
    };
    this.setState({
      Queue: [...Queue, notification],
      id
    })
  }

  setParams(params) {
    const { defaultParams } = this.state;
    this.setState({
      defaultParams: { ...defaultParams, ...params }
    })
  }

  getGroupedQueue() {
    const { Queue } = this.state;
    let groupedQueue = _.groupBy(Queue, 'position');
    return Object.keys(groupedQueue).map(key => {
      return {
        position: key,
        items: groupedQueue[key]
      }
    })
  }

  render() {
    let groupedQueue = this.getGroupedQueue();
    const { classes } = this.props;
    return (
      <Fragment>
        {
          groupedQueue.map((Queue, index) =>
            <Layer
              key={index}
              modal={false}
              position="center"
              className={classes.transparent}
            >
                {
                  Queue.items.map((item, subIndex) =>
                    <Box direction="column" align="center" key={subIndex} className={classes.transparent}>
                      <NotificationComponent item={item} deleteNotificationsFromQueue={this.deleteNotificationsFromQueue}/>
                    </Box>
                  )
                }
            </Layer>
          )
        }
      </Fragment>
    );
  }
}

NotificationsComponent.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(NotificationsComponent);
